import React from "react";
import { resultsExportActions } from "../../modules/results-export";
import { connect } from "react-redux";
import isNil from "lodash/isNil";

class ResultsDownloader extends React.Component {
    static mapStateToProps(state, props) {
        return {
            downloadState: state.resultsExport,
            forceFileRegeneration:
                !isNil(props.forceFileRegeneration) &&
                props.forceFileRegeneration
        };
    }

    static mapDispatchToProps(dispatch) {
        return {
            exportResults: (wevoId, forceFileRegeneration) =>
                dispatch(
                    resultsExportActions.downloadResultExport(
                        wevoId,
                        forceFileRegeneration
                    )
                )
        };
    }

    downloadFile() {
        this.props.exportResults(
            this.props.wevoId,
            this.props.forceFileRegeneration
        );
    }

    render() {
        return (
            <button
                onClick={() => {
                    if (!this.props.downloadState.loading) {
                        this.downloadFile();
                    }
                }}
                className={this.props.className}
            >
                {this.props.children}
            </button>
        );
    }
}

export default connect(
    ResultsDownloader.mapStateToProps,
    ResultsDownloader.mapDispatchToProps
)(ResultsDownloader);



// WEBPACK FOOTER //
// ./src/components/Results/ResultsDownloader.js